import { render } from "./CustomdropdownComponent.vue?vue&type=template&id=65671689"
import script from "./CustomdropdownComponent.vue?vue&type=script&lang=js"
export * from "./CustomdropdownComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__